import styled from "styled-components";

export const TableDarkHeader = styled.div`
  width: 100%;
  background: var(--gradient-header);
  color: #fff;
  padding: var(--space-3) var(--space-4);
  text-align: center;
  font-weight: var(--font-semibold);
  font-size: var(--text-xl);
  text-transform: capitalize;
  border-radius: var(--radius-md) var(--radius-md) 0 0;
  box-shadow: var(--shadow-subtle);
`;
